var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, InfoOutlined, InsertLinkOutlined } from '@mui/icons-material';
import { IconButton, LinearProgress, styled } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { v4 } from 'uuid';
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from '../../../../../../../assets/customIcons';
import { BarcodeScan } from '../../../../../../../assets/images';
import { FormRadios } from '../../../../../../../builderPackage/components/dynamicFormBuilder/components/formRadios';
import { DynamicFormBuilderContainer } from '../../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { MuiStack } from '../../../../../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../../../../../constants';
import { showNewNotification } from '../../../../../../../redux/commonSlice';
import { resetState } from '../../../../../../../redux/crudSlice';
import { faintblue } from '../../../../../../../theme/palette';
import { systemColor } from '../../../../../../../theme/systemColor';
import { getLocalStorageItem } from '../../../../../../../utils/storageHelper';
import { isLoadingState } from '../../../../../../../utils/utils';
import { interWarehouseRequisitionDeleteAttachmentAPICall } from '../../interWarehouseStockTransferRequisition/services/apiCall';
import InterWarehouseInwardPartDetails from '../components/interWarehouseInwardPartDetails';
import { CreateInterWarehouseInwardAPICall, InterInwardDetailsAPICall, InterWarehousePriorityListAPICall, InterWarehouseTransferInWardIdAPI, uploadInterInwardAttachmentAPICall } from '../services/apiCall';
import { InterWarehouseInwardKeys, InterWarehouseInwardPartDetailsMandatoryFeilds, InwardApiKeys } from '../services/entity';
var discrepancyItem = [{
        id: '0',
        radioName: 'Yes'
    }, {
        id: '1',
        radioName: 'No'
    }];
function CreateInterWarehouseInward() {
    var _this = this;
    var _getLocalStorageItem, _getLocalStorageItem2;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var RadioButton = styled(function (props) { /*#__PURE__*/ return React.createElement(FormRadios, {
        options: discrepancyItem,
        name: "discrepancy",
        defaultValue: "1",
        displayExpr: 'radioName'
    }); })(function (_ref) {
        var theme = _ref.theme;
        return {
            '& .MuiFormControl-root': {
                justifyContent: 'space-between',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                m: 0
            }
        };
    });
    var SetTransferOutwardIdFunc = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, InterInwardDetailsAPICall({
                        request: {
                            id: value === null || value === void 0 ? void 0 : value.id
                        }
                    })];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 ? void 0 : result.statusCode) == 200 && result !== null && result !== void 0 && result.success && result !== null && result !== void 0 && result.data)
                        return [2 /*return*/, result];
                    return [2 /*return*/];
            }
        });
    }); };
    var request = {
        SourceTenantId: UserOrganization,
        SourceParentTenantId: UserParentOrganization,
        DestinationTenantId: UserOrganization,
        DestinationParentTenantId: UserParentOrganization,
        Type: "WToWInward",
        DocumentDate: new Date().toISOString(),
        Status: "Draft"
    };
    var General = [{
            type: FormItemTypes.CardComponent,
            name: 'GeneralTabs',
            label: 'General Tabs',
            value: null,
            columnSize: 12,
            variant: 'outlined',
            title: 'Basic details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'TransferOutID',
                    label: 'Transfer outward ID',
                    placeholder: 'Transfer outward ID',
                    required: true,
                    value: null,
                    valueExpr: "id",
                    displayExpr: "DocumentCode",
                    apiKey: InterWarehouseInwardKeys.TransferOutward,
                    getListData: InterWarehouseTransferInWardIdAPI,
                    setFormState: function (formValues, currValue, field) { return __awaiter(_this, void 0, void 0, function () {
                        var response, _response$data, _response$data2, _response$data3, _response$data4, _response$data5, _response$data6, _response$data7, _response$data8, _response$data9, _response$data10, _response$data11, _response$data12, _response$data13, _response$data14;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, SetTransferOutwardIdFunc(currValue)];
                                case 1:
                                    response = _a.sent();
                                    if (response !== null && response !== void 0 && response.data) {
                                        return [2 /*return*/, _objectSpread(_objectSpread({}, response === null || response === void 0 ? void 0 : response.data), {}, {
                                                TransporterName: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.TransportDetail) === null || _response$data === void 0 ? void 0 : _response$data.TransporterName,
                                                SourceWarehouseName: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 || (_response$data2 = _response$data2.SourceWarehouse) === null || _response$data2 === void 0 ? void 0 : _response$data2.Name,
                                                DestinationTenantName: response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 || (_response$data3 = _response$data3.DestinationWarehouse) === null || _response$data3 === void 0 ? void 0 : _response$data3.Name,
                                                PriorityId: response === null || response === void 0 || (_response$data4 = response.data) === null || _response$data4 === void 0 || (_response$data4 = _response$data4.Priority) === null || _response$data4 === void 0 ? void 0 : _response$data4.id,
                                                ShippingDocumentDate: response === null || response === void 0 || (_response$data5 = response.data) === null || _response$data5 === void 0 || (_response$data5 = _response$data5.TransportDetail) === null || _response$data5 === void 0 ? void 0 : _response$data5.ShippingDocumentDate,
                                                ShippingMethodName: response === null || response === void 0 || (_response$data6 = response.data) === null || _response$data6 === void 0 || (_response$data6 = _response$data6.TransportDetail) === null || _response$data6 === void 0 ? void 0 : _response$data6.ShippingMethodName,
                                                ShippingDocumentNo: response === null || response === void 0 || (_response$data7 = response.data) === null || _response$data7 === void 0 || (_response$data7 = _response$data7.TransportDetail) === null || _response$data7 === void 0 ? void 0 : _response$data7.ShippingDocumentNo,
                                                PermitNo: response === null || response === void 0 || (_response$data8 = response.data) === null || _response$data8 === void 0 || (_response$data8 = _response$data8.TransportDetail) === null || _response$data8 === void 0 ? void 0 : _response$data8.PermitNo,
                                                VehicleNo: response === null || response === void 0 || (_response$data9 = response.data) === null || _response$data9 === void 0 || (_response$data9 = _response$data9.TransportDetail) === null || _response$data9 === void 0 ? void 0 : _response$data9.VehicleNo,
                                                BoxQuantity: response === null || response === void 0 || (_response$data10 = response.data) === null || _response$data10 === void 0 || (_response$data10 = _response$data10.TransportDetail) === null || _response$data10 === void 0 ? void 0 : _response$data10.BoxQuantity,
                                                ExpectedTransferDate: response === null || response === void 0 || (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : _response$data11.ExpectedTransferDate,
                                                ExpectedPickupDate: response === null || response === void 0 || (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.ExpectedPickupDate,
                                                StatusName: response === null || response === void 0 || (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : _response$data13.StatusName,
                                                Type: "WToWInward",
                                                ParentId: response === null || response === void 0 || (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : _response$data14.id
                                            })];
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'SourceWarehouseName',
                    label: 'Source warehouse',
                    placeholder: 'Source warehouse',
                    disabled: true,
                    required: true,
                    value: null
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'DestinationTenantName',
                    label: 'Destination warehouse',
                    placeholder: 'Destination warehouse',
                    disabled: true,
                    required: true,
                    value: null
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PriorityId',
                    label: 'Priority',
                    value: null,
                    placeholder: 'Priority',
                    getListData: InterWarehousePriorityListAPICall,
                    apiKey: InterWarehouseInwardKeys.PriorityList,
                    disabled: true
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: 'LogisticDetail',
            label: 'Logistic details',
            value: null,
            columnSize: 12,
            variant: 'outlined',
            title: 'Logistic details',
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'TransporterName',
                    label: 'Transporter name',
                    placeholder: 'Transporter name',
                    disabled: true,
                    value: null
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'ShippingMethodName',
                    label: 'Shipping method',
                    placeholder: 'Shipping method',
                    disabled: true,
                    value: null
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'ShippingDocumentNo',
                    label: 'Shipping doc number',
                    placeholder: 'Shipping doc number',
                    disabled: true,
                    value: null
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'ShippingDocumentDate',
                    label: 'Shipping doc date',
                    placeholder: 'Shipping doc date',
                    disabled: true,
                    value: null
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'PermitNo',
                    label: 'Road permit number',
                    placeholder: 'Road permit number',
                    disabled: true,
                    value: null
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'VehicleNo',
                    label: 'Vehicle number',
                    placeholder: 'Vehicle number',
                    disabled: true,
                    value: null
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'BoxQuantity',
                    label: 'No. of boxes',
                    placeholder: 'No. of boxes',
                    disabled: true,
                    value: null
                }]
        }];
    var PartDetails = [{
            type: FormItemTypes.CardComponent,
            name: 'InwardPartDetails',
            columnSize: 12,
            variant: 'outlined',
            title: 'Part details',
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'BarcodeScan',
                    label: 'Barcode Scan',
                    placeholder: 'Scanned part details',
                    maxLength: 100,
                    disabled: true,
                    InputProps: {
                        endAdornment: /*#__PURE__*/ React.createElement(MuiStack, {
                            borderLeft: '1px solid #DEE4EB',
                            paddingLeft: 1,
                            width: '36px'
                        }, /*#__PURE__*/ React.createElement(IconButton, {
                            id: "eyeIconId",
                            sx: {
                                alignContent: 'center'
                            }
                        }, /*#__PURE__*/ React.createElement("img", {
                            height: 20,
                            width: 20,
                            src: BarcodeScan
                        })))
                    },
                    sx: {
                        '& .MuiInputBase-input': {
                            borderRadius: '8px 0px 0px 8px'
                        }
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'checkboxContainer',
                    alignItems: 'center',
                    spacing: 0,
                    flexDirection: 'column',
                    flexWrap: 'nowrap',
                    columnSize: 3,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            alignItems: 'center',
                            columnSize: 12,
                            flexDirection: 'row',
                            flexWrap: 'nowrap',
                            justifyContent: 'flex-start',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'Discrepancy',
                                    children: 'Any discrepancy',
                                    columnSize: 0,
                                    whiteSpace: 'nowrap'
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: "info",
                                    id: "info",
                                    columnSize: 0,
                                    children: /*#__PURE__*/ React.createElement(InfoOutlined, {
                                        fontSize: "small",
                                        sx: {
                                            color: "secondary"
                                        }
                                    })
                                }]
                        }, {
                            type: FormItemTypes.CheckBox,
                            name: 'IsDiscrepancy',
                            label: '',
                            value: false,
                            columnSize: 12,
                            formControlLabelProps: {
                                control: /*#__PURE__*/ React.createElement(RadioButton, {
                                    sx: {
                                        mx: 1
                                    }
                                }),
                                sx: {
                                    color: '#1B1D21',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.Custom,
            name: "StockTransferRequisitionDetail",
            columnSize: 12,
            validator: function (values, state) {
                var error = undefined;
                values === null || values === void 0 || values.find(function (r) {
                    var _Object$keys;
                    var errorField = (_Object$keys = Object.keys(InterWarehouseInwardPartDetailsMandatoryFeilds)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (field) { return typeof r[field] !== 'number' && typeof r[field] !== 'boolean' && !r[field]; });
                    if (errorField) {
                        error = {
                            id: v4(),
                            rowId: r.id,
                            field: InterWarehouseInwardPartDetailsMandatoryFeilds[errorField],
                            message: 'This field is required',
                            value: r[errorField]
                        };
                    }
                    return Boolean(errorField);
                });
                return error;
            },
            setFormState: function (formValues, currValue, field) {
                var damageQty = 0;
                var excessQty = 0;
                var qty = 0;
                var amt = 0;
                for (var _i = 0, currValue_1 = currValue; _i < currValue_1.length; _i++) {
                    var value = currValue_1[_i];
                    damageQty = damageQty + value.DamageQuantity;
                    excessQty = excessQty + value.ExcessQuantity;
                    qty = qty + value.ActualRecievedQty;
                    amt = amt + value.ActualRecievedQty * value.PurchasePrice;
                }
                return _objectSpread(_objectSpread({}, formValues), {}, {
                    TotalDamageQuantity: damageQty,
                    TotalExcessQuantity: excessQty,
                    TotalQuantity: qty,
                    TotalAmount: amt
                });
            },
            element: InterWarehouseInwardPartDetails
        }];
    var AdditionalInformation = [{
            type: FormItemTypes.CardComponent,
            name: 'InwardNotesAndAttachments',
            label: 'Notes & attachments',
            value: null,
            columnSize: 12,
            variant: 'outlined',
            title: 'Notes & attachments',
            elements: [{
                    type: FormItemTypes.DatePicker,
                    name: 'ExpectedTransferDate',
                    label: 'Transferred date',
                    disabled: true,
                    value: null
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'ExpectedPickupDate',
                    label: 'Pickup date',
                    disabled: true,
                    value: null
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    label: '',
                    value: null,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'InwardTransferReason',
                            label: 'Transfer reasons (0/200 characters)',
                            placeholder: 'Enter reasons',
                            setFieldProps: function (formValues, value) {
                                var _value$length;
                                return {
                                    type: this.type,
                                    label: "Transfer reasons (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/200 characters)")
                                };
                            },
                            required: true,
                            multiline: true,
                            value: null,
                            md: 6,
                            maxLength: 200,
                            minRows: 2
                        }, {
                            type: FormItemTypes.Attachment,
                            name: 'ImageAttachments',
                            label: 'Add attachments',
                            placeholder: 'Upload Files',
                            value: null,
                            inputProps: {
                                accept: 'application/*',
                                multiple: true
                            },
                            uploadAttachmentRequest: {
                                systemname: InterWarehouseInwardKeys.AttachmentSystemName
                            },
                            uploadAttachmentAPI: uploadInterInwardAttachmentAPICall,
                            deleteAttachmentAPI: interWarehouseRequisitionDeleteAttachmentAPICall
                        }]
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'General',
            elements: General
        }, {
            id: '1',
            label: 'Part details',
            elements: PartDetails
        }, {
            id: '2',
            label: 'Additional information',
            elements: AdditionalInformation
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "felx-start",
            alignItems: "center",
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: 'back-icon',
                    id: 'back-icon',
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small"
                    }),
                    onClick: function () {
                        dispatch(resetState(InwardApiKeys)), navigate('/interWarehouseInward');
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'New inter warehouse inward',
                    columnSize: 0,
                    variant: 'h1',
                    noWrap: true
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'QuickLink',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'quick-links',
                    children: 'Quick Links',
                    columnSize: 0,
                    variant: 'text',
                    startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                    sx: {
                        background: 'none'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'DownloadIcon',
                    children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                    columnSize: 0,
                    color: 'secondary',
                    variant: 'outlined',
                    sx: {
                        p: 1
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'ShareIcon',
                    children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary',
                    sx: {
                        p: 1
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'PrintIcon',
                    children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary',
                    sx: {
                        p: 1
                    }
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 0,
                    height: '100%',
                    width: '2px',
                    bgcolor: 'rgba(0,0,0,0.1)',
                    mx: 1
                }, {
                    type: FormItemTypes.Button,
                    name: 'Save',
                    children: 'Save',
                    id: 'save',
                    columnSize: 0,
                    variant: 'contained',
                    onClick: function () { return 'submit'; }
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Stepper',
            tabs: tabs,
            valueExpr: 'id',
            displayExpr: 'label',
            columnSize: 12,
            variant: 'scrollable',
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 1,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingBottom: 2,
                paddingX: 2,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Save',
                    children: 'Save',
                    id: 'save',
                    columnSize: 0,
                    variant: 'contained',
                    onClick: function () { return 'submit'; }
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoadingState(InwardApiKeys) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        formProps: {
            bgcolor: faintblue
        },
        createKey: InterWarehouseInwardKeys.Create,
        createFormAPI: CreateInterWarehouseInwardAPICall,
        createRequest: request,
        onClose: function () {
            dispatch(showNewNotification({
                isOpen: true,
                title: 'Success',
                message: 'Save Successfully',
                type: 'success'
            }));
            navigate(-1);
        }
    }));
}
export default CreateInterWarehouseInward;
